var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M4.78882 12L4.43526 11.6464L4.08171 12L4.43526 12.3536L4.78882 12ZM19.7888 12.5C20.065 12.5 20.2888 12.2761 20.2888 12C20.2888 11.7239 20.065 11.5 19.7888 11.5V12.5ZM10.4353 5.64645L4.43526 11.6464L5.14237 12.3536L11.1424 6.35355L10.4353 5.64645ZM4.43526 12.3536L10.4353 18.3536L11.1424 17.6464L5.14237 11.6464L4.43526 12.3536ZM4.78882 12.5H19.7888V11.5H4.78882V12.5Z",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow_left.b1fa62cfcef8efcd1319eff0369d5b7d.svg";
export { ForwardRef as ReactComponent };